import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Button } from 'foundations-components/transitional/components/Button';
import MobileFilterBar from 'marketplace-ui-common/components/mobile/MobileFilterBar';
import { useIsMaxScreenSize } from 'marketplace-ui-common/hooks/useScreenSize';
import { Fragment } from 'react';
import FilterTag, { MobileFilterTag } from './FilterTag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ClearFiltersButton({
  onClear
}) {
  return /*#__PURE__*/_jsx(Button, {
    marginInlineStart: "300",
    onClick: () => onClear(),
    responsive: false,
    use: "link",
    children: /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.themes.results.clearFilters"
      })
    })
  });
}
function DesktopResultsFilters({
  filters,
  onClearAllFilters,
  onClearFilter
}) {
  if (!filters.length) return null;
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    wrap: "wrap",
    children: [filters.map(({
      name,
      value
    }) => /*#__PURE__*/_jsx(FilterTag, {
      onClear: onClearFilter,
      name: name,
      value: value
    }, `filter-tag-${name}-${value}`)), /*#__PURE__*/_jsx(ClearFiltersButton, {
      onClear: () => onClearAllFilters()
    })]
  });
}
function MobileResultsFilters({
  filters,
  onClearAllFilters,
  onClearFilter,
  onOpenFilterPanel,
  resultsFiltersRef
}) {
  return /*#__PURE__*/_jsx(MobileFilterBar, {
    startSlot: /*#__PURE__*/_jsx("div", {
      ref: resultsFiltersRef,
      children: /*#__PURE__*/_jsx(Button, {
        onClick: () => onOpenFilterPanel(),
        size: "sm",
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.results.filter"
        })
      })
    }),
    middleSlot: /*#__PURE__*/_jsxs(Fragment, {
      children: [filters.map(({
        name,
        value
      }) => /*#__PURE__*/_jsx(MobileFilterTag, {
        onClear: onClearFilter,
        name: name,
        value: value
      }, `filter-tag-${name}-${value}`)), filters.length > 0 && /*#__PURE__*/_jsx(ClearFiltersButton, {
        onClear: () => onClearAllFilters()
      })]
    })
  });
}
function ResultsFilters(props) {
  const isMobile = useIsMaxScreenSize('lg');
  if (isMobile) {
    return /*#__PURE__*/_jsx(MobileResultsFilters, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(DesktopResultsFilters, Object.assign({}, props));
}
export default ResultsFilters;